export var getInitialBuilding = function (key) {
    var storedBuilding = localStorage.getItem("building_" + key);
    return storedBuilding ? JSON.parse(storedBuilding) : undefined;
};
export var storeBuilding = function (building, key) {
    localStorage.setItem("building_" + key, JSON.stringify(building));
};
